import { render, staticRenderFns } from "./PaymentConsumerRow.vue?vue&type=template&id=0fa4addc&"
import script from "./PaymentConsumerRow.vue?vue&type=script&lang=js&"
export * from "./PaymentConsumerRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports